import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import WelcomePage from './components/WelcomePage';
import BusinessSetup from './components/BusinessSetup';
import CardLayoutSelection from './components/CardLayoutSelection';
import CardDetailsCustomization from './components/CardDetailsCustomization';
import Dashboard from './components/Dashboard';
import CardCreator from './components/CardCreator';
import Login from './components/Login';
import Register from './components/Register';

const RequireAuth = ({ children }) => {
  const token = localStorage.getItem('authToken');
  if (!token) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/" element={<WelcomePage />} />
        <Route path="/setup/business-info" element={<RequireAuth><BusinessSetup /></RequireAuth>} />
        <Route path="/setup/card-layout" element={<RequireAuth><CardLayoutSelection /></RequireAuth>} />
        <Route path="/setup/card-details" element={<RequireAuth><CardDetailsCustomization /></RequireAuth>} />
        <Route path="/dashboard" element={<RequireAuth><Dashboard /></RequireAuth>} />
        <Route path="/create-card" element={<RequireAuth><CardCreator /></RequireAuth>} />
      </Routes>
    </Router>
  );
}

export default App;